export default __webpack_public_path__ + "static/media/message-delivered.fbc54350.svg";